import styles from './fieldList.module.css'
import { FieldRow } from '../field-row/fieldRow'
import { Field } from '../fields/field/field'
import { FormField, FieldValue, FieldType } from '../types'
import { Validatable } from '../validatable/validatable'
import { toList } from '../../../../utils/listUtils'
import { ValidationResult } from '../form/types'
import { Spinner } from '../spinner/spinner'

type Props = {
    fields: FormField[]
    validationResults?: ValidationResult
    onChange?: (field: FormField, value?: FieldValue) => void
}

// TODO ver si puedo usar esto en form
export const FieldList = (props: Props) => {
    const { fields, validationResults = {}, onChange } = props
    
    const handleChange = (field: FormField) => (value?: FieldValue) => {
        onChange && onChange(field, value)
        field.onChange && field.onChange(value)
    }

    return (
        <div className={styles.container}>
            {fields.map(field => (
                <FieldRow
                    key={field.name}
                    id={field.name}
                    label={field.label}
                    labelSpace={field.labelSpace}
                    hint={field.hint}
                    hideLabel={field.type === FieldType.BOOLEAN}
                    narrow={field.narrow}
                >
                    {field.loading ? <Spinner centered={false} /> : (
                        field.render ? field.render() : (
                            <Validatable validations={toList(validationResults[field.name])} left>
                                <Field field={field} onChange={handleChange(field)} />
                            </Validatable>
                        )
                    )}
                </FieldRow>
            ))}
        </div>
    )
}
